<template>
  <div id="index">
    <div class="common-serve">
      <img src="../assets/img/hello.gif" alt="BodorGPT" @click="togglePage(gptItem)" />
    </div>
    <div class="navbar">
      <a class="title" v-if="screenSize > 1200" @click="index">Bodor+ 3.0</a>
      <div class="navcontent" :class="{ navcontentFont: screenSize < 1200 }">
        <div
          v-for="(item, index) in menuItems"
          :key="item.id"
          class="navitems"
          :class="{ active: isActive(item) }"
          @click="togglePage(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <img :src="avatar" class="headimg" alt="..." ref="headimg" />
      <div class="usermenu" ref="usermenu">
        <div class="usermenuitems" @click="usercenter">{{ $t("index.user") }}</div>
        <div class="usermenuitems" @click="back">{{ $t("index.logOut") }}</div>
      </div>
    </div>
    <router-view></router-view>
    <PageFooter />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
// import { initSignalR, closeSignalR } from "@/common/dau/dauTracker";
import { initSignalR, closeSignalR } from "@/utils/signalR";

const { t } = useI18n();

import PageFooter from "@/components/PageFooter.vue";
//获取屏幕宽度
const screenSize = ref();
const width = window.innerWidth;
screenSize.value = width;
let router = useRouter();
const gptItem = ref({ id: "bodorGpt", name: "BodorGPT" });

const menuItems = ref([
  { id: "device", name: t("index.myDevice") },
  { id: "task", name: t("index.task") },
  { id: "software", name: t("index.software") },
  { id: "cam", name: t("index.cam") },
  { id: "knowledge", name: t("index.knowledge") },
  { id: "use", name: t("index.use") },
  { id: "repair", name: t("index.repair") },
  { id: "maintenance", name: t("index.maintenance") },
  // { id: "file", name: t("index.file") },
  { id: "bodorGpt", name: "BodorGPT" },
  { id: "official", name: t("index.official") },
]);
const avatar = ref();
const activeItem = ref(null);

let user = JSON.parse(localStorage.getItem("user"));
let token = localStorage.getItem("token");
avatar.value = user.Url
  ? "https://apicloud.bodor.com" + user.Url
  : require("@/assets/img/header.png");

function isActive(item) {
  return item === activeItem.value;
}
function togglePage(item) {
  if (item.id == "official") {
    const url = `https://www.bodor.cn?token=${token}`;
    window.open(url, "_blank");
  } else {
    activeItem.value = item;
    router.push(`/index/${item.id}`);
  }
}
let backRouter = localStorage.getItem("router");

if (backRouter) {
  menuItems.value.forEach((items) => {
    if (items.id == backRouter) {
      togglePage(items);
      return;
    }
  });
} else {
  togglePage(menuItems.value[0]);
}
const index = () => {
  location.reload();
  togglePage(menuItems.value[0]);
};
const back = async () => {
  await closeSignalR();
  // initSignalR();
  let lang = localStorage.getItem("lang");
  localStorage.clear();
  localStorage.setItem("lang", lang);
  router.push("/");
};
const usercenter = () => {
  router.push("/usercenter");
};
onMounted(() => {});
</script>

<style scoped>
#index {
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
  display: flex;
}

.usermenu {
  width: 120px;
  height: 0px;
  overflow: hidden;
  align-items: center;
  position: absolute;
  box-shadow: 0 10px 10px -2px #0000001f;
  transition: all 0.5s;
  top: 60px;
  right: 123px;
  z-index: 100;
  transform: translate(50%, 0%);
}

.usermenuitems {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: black;
  cursor: pointer;
}

.usermenuitems:hover {
  background-color: #eeeeee;
}

.title {
  font-weight: bold;
  font-size: 24px;
  cursor: pointer;
  color: white;
  position: absolute;
}

.navbar {
  width: 100%;
  box-sizing: border-box;
  height: 60px;
  border: solid #ddd;
  border-width: 0 0 1px;
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  background: rgba(29, 29, 31, 0.7);
  position: fixed;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 100px;
  color: white;
  border-radius: 0px;
}

.navcontent {
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0px auto;
}
.navcontentFont {
  font-size: 12px;
}

.navitems {
  height: 100%;
  padding: 0 15px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
}

.active {
  border-bottom: 3px solid rgb(255, 70, 16);
}

.headimg {
  width: 45px;
  height: 45px;
  border-radius: 100%;
  cursor: pointer;
  position: absolute;
  right: 5%;
}

.headimg:hover ~ .usermenu {
  height: 100px;
}

.usermenu:hover {
  height: 100px;
}

@media (max-width: 767px) {
  .navbar {
    padding: 0px 20px;
  }
}
.common-serve {
  position: fixed;
  right: 0;
  bottom: 20%;
  width: 100px;
  height: 100px;
  cursor: pointer;
  z-index: 999;
}
.common-serve img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
</style>
